import { ApiUserRole, type ChatDialogResponse } from '@/core/generated/api';
import type { ChatCompanion } from '@/entities/Chat/model/types';

/** Преобразует участника приложения в карточку собеседника */
export const appDialogToCompanion = (dialog: ChatDialogResponse | null): ChatCompanion | null => {
    if (!dialog?.companionAppUserId) return null;
    const role = dialog.companionRole?.id;

    if (role !== ApiUserRole.Client && role !== ApiUserRole.Executor) return null;
    return {
        id: dialog.companionAppUserId,
        name: dialog.companionName ?? 'Собеседник',
        photoUrl: dialog.companionAvatarUrl ?? null,
        role: role === ApiUserRole.Client
            ? 'Client'
            : 'Executor',
        displayNameRole: dialog.companionRole?.name ?? '',
    };
};
